module.exports = __webpack_public_path__ + "img/jack-o-lantern.a38892eb.svg";